









function toTitleCase(str) { return str.replace(/\w\S*/g, function (txt) { return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(); }); }










var checkExist = setInterval(function () {





	if ( $('div.collection-listing').length ) {

		total_products = [];





		// Get current tags

		if ( location.href.indexOf('?') !== -1 ) {
			url_tags = location.href.split('?').pop().split('&');
		} else {
			url_tags = []
		}

		product_type = [];
		genre = [];
		grl = [];
		grade_level = [];
		all_tags = [];





		if ( url_tags.length != 0 ) {





			// Append tags to tag categories

			for ( i = 0; i < url_tags.length; i++ ) {

				k = url_tags[i].split('=')[0];
				v = url_tags[i].split('=')[1];

				if (k == 'product-type') product_type.push(v);
				if (k == 'genre') genre.push(v);
				if (k == 'reading-level') grl.push(v);
				if (k == 'grade-level') grade_level.push(v);

				all_tags.push(v);

			}





			// Append relevant products to Total Products

			$.each($('div.collection-listing').children('div.product-listing-new'), function () {

				tags = $(this).data('tags').split(';');

				included = ((product_type.some(v => tags.includes(v)) || product_type.length == 0) && (genre.some(v => tags.includes(v)) || genre.length == 0) && (grl.some(v => tags.includes(v)) || grl.length == 0) && (grade_level.some(v => tags.includes(v)) || grade_level.length == 0))

				if (!included) {
					$(this).detach();
				} else {
					total_products.push($(this));
					$('div.collection-listing').append($(this));
					$(this).css('display', 'block');
					$(this).find('select.varid').prop('selectedIndex', 0);
				}

			});





			// Change total product count description

			$('#total-products').html('1 of ' + total_products.length + ' (' + total_products.length + ' Products)');





			// Add helper text if no products in filtered collection

			if ( total_products.length == 0 ) {
				$('div.collection-listing').html("<p style = 'line-height: 29px;'>Sorry, there are no products that meet the search criteria you've selected. For further assistance, contact us at toll-free 866-918-6173 or email us at Info@HamerayPublishing.com. If you would like a price quote for a custom list of books or book sets, <b><a href = 'https://www.hameraypublishing.com/pages/quote-request'>please fill out our Quote Form here</a></b>.</p><br>");
			}





		}














		$.each($('a.filter-link'), function () {

			filter_option = $(this).parent().attr('data-filter-option');
			filter_pair = $(this).parent().attr('data-filter-group') + '=' + filter_option
			filter_remove_url = window.location.href.replace(filter_pair, '')

			if (filter_remove_url.substr(filter_remove_url.length - 1) == '&') {
				filter_remove_url = filter_remove_url.substring(0, filter_remove_url.length - 1);
			}

			if (filter_remove_url.substr(filter_remove_url.length - 1) == '?') {
				filter_remove_url = filter_remove_url.substring(0, filter_remove_url.length - 1);
			}

			filter_remove_url = filter_remove_url.replace('?&', '?');
			filter_remove_url = filter_remove_url.replace('&&', '&');


			if (all_tags.includes(filter_option)) {
				$(this).parent().addClass('active');
				current_filter_title = toTitleCase(filter_option.replace(/-/g, ' ')).replace(' Cd', ' CD').replace(' Y ', ' y ').replace(' El ', ' el ').replace(' De ', ' de ').replace(' Las ', ' las ').replace(' Los ', ' los ').replace(' La ', ' la ').replace(' And ', ' and ').replace(' The ', ' the ');
				$('ul#filter-current').append('<li class = "active"><a href = "' + filter_remove_url + '">' + current_filter_title + '</a></li>');
			} else {
				$(this).parent().removeClass('active');
			}

		});





		$('a.filter-link').click(function (event) {

			event.preventDefault();

			current_url = window.location.href;

			param = $(this).parent().attr('data-filter-group') + '=' + $(this).parent().attr('data-filter-option');

			if (current_url.indexOf(param) !== -1) {

				current_url = current_url.replace(param, '');

				if (current_url.substr(current_url.length - 1) == '&') {
					current_url = current_url.replace('&', '');
				}

				if (current_url.substr(current_url.length - 1) == '?') {
					current_url = current_url.replace('?', '');
				}

				current_url = current_url.replace('?&', '?');
				current_url = current_url.replace('&&', '&');

			} else {

				if (current_url.indexOf('?') > -1) {
					current_url += '&' + param;
				} else {
					current_url += '?' + param;
				}

			}

			window.location.href = current_url;

		});





		clearInterval(checkExist);

	}

}, 100);















function defer(method) {
	if (window.jQuery) {
		method();
	} else {
		setTimeout(function () {
			defer(method)
		}, 1000);
	}
}

defer(function () {

	$('.filter-toggle').click(function () {

		if ($('.mobile-filter').hasClass('visible')) {

			$('.filter-toggle span').text('Collapse Filter');

		} else {

			$('.filter-toggle span').text('Filter Collection');

		}

	});

	$('.filter-group').last().addClass('filter-group-last');

});